import { RootState, AzureAdStatus } from "./types";

export default {
    reload(state: RootState) {
        state.reload++;
    },
    loadAzureAdStatusSuccess(state: RootState, data: AzureAdStatus) {
        state.azureAdStatus = data;
        state.azureAdStatus.loaded = true;
    },
    updateAllowStockImages(state: RootState, value: boolean) {
        state.allowStockImages = value;
    }
};
